import { round } from 'lodash';

type CapitalBreakdownEntry = {
  commitmentId: string;
  amountLcy: number;
  fundsCalled?: {
    fromCommitmentLcy: number;
    fromRecallableDistributionLcy: number;
  };
};

export default function useAllocationChangeHandler({
  capitalBreakdown,
  onAllocationsChange,
  keepCallAmountFixed,
}: {
  capitalBreakdown: Array<CapitalBreakdownEntry>;
  onAllocationsChange: (allocations: Array<CapitalBreakdownEntry>) => void;
  keepCallAmountFixed: boolean;
}) {
  return (
    commitmentId: string,
    valueName: 'fromCommitmentLcy' | 'fromRecallableDistributionLcy',
    value: number,
  ) => {
    const breakdownIndex = capitalBreakdown.findIndex(
      (c) => c.commitmentId === commitmentId,
    );
    if (breakdownIndex < 0) {
      return;
    }

    capitalBreakdown[breakdownIndex].fundsCalled = {
      fromCommitmentLcy:
        capitalBreakdown[breakdownIndex].fundsCalled?.fromCommitmentLcy ?? 0,
      fromRecallableDistributionLcy:
        capitalBreakdown[breakdownIndex].fundsCalled
          ?.fromRecallableDistributionLcy ?? 0,
    };

    if (keepCallAmountFixed) {
      capitalBreakdown[breakdownIndex].fundsCalled[valueName] = value;

      const oppositeValueName =
        valueName === 'fromCommitmentLcy'
          ? 'fromRecallableDistributionLcy'
          : 'fromCommitmentLcy';
      capitalBreakdown[breakdownIndex].fundsCalled[oppositeValueName] = round(
        capitalBreakdown[breakdownIndex].amountLcy - value,
        2,
      );
    } else {
      capitalBreakdown[breakdownIndex].fundsCalled[valueName] = value;

      capitalBreakdown[breakdownIndex].amountLcy = round(
        (capitalBreakdown[breakdownIndex].fundsCalled?.fromCommitmentLcy ?? 0) +
          (capitalBreakdown[breakdownIndex].fundsCalled
            ?.fromRecallableDistributionLcy ?? 0),
        2,
      );
    }

    onAllocationsChange(capitalBreakdown);
  };
}
